import axios from "axios";

export default axios.create({
  // baseURL: "http://localhost:3500/api/",
  // baseURL: "http://www.marfishapi.com:3500/api/",
  baseURL: "./api/",
});

// var currentUrl = window.location.href;
// var getHttp = currentUrl.split("/");

// export const config = {
//   Api: getHttp[0] + "//localhost:3500/api/",
// };
